import { render, staticRenderFns } from "./FracionarPedidos.vue?vue&type=template&id=240153ee"
import script from "./FracionarPedidos.vue?vue&type=script&setup=true&lang=js"
export * from "./FracionarPedidos.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports